import ImageTextCarouselGrid from "hec/components/image-text-carousel-grid";
import type { ImageTextCarouselGridProps } from "hec/components/image-text-carousel-grid/types";

import type { RegisteredComponent } from "@builder.io/sdk-react";

import {
  buttonNavigationColorInput,
  iconsHeaderTextInput,
  imageTextItemsInput,
  slidePaddingInput,
  slidesVisibleInput,
} from "./inputs";

const ImageTextCarouselGridBuilder = (
  props: ImageTextCarouselGridProps & { attributes?: Record<string, unknown> },
) => {
  return (
    <ImageTextCarouselGrid
      data-testid="builder-block__ImageTextCarouselGrid"
      {...props}
    />
  );
};

export const ImageTextCarouselGridDefinition = {
  component: ImageTextCarouselGridBuilder,
  name: "ImageTextCarouselGrid",
  noWrap: true,
  inputs: [
    iconsHeaderTextInput,
    imageTextItemsInput,
    slidesVisibleInput,
    slidePaddingInput,
    buttonNavigationColorInput,
  ],
} satisfies RegisteredComponent;
